<template>
  <div class="column-inbox">
    <ul @click="redirecFuncionalidade(row)">
      <li class="title">
        <svg-icone class="icone-nova-msg" v-if="row[column.field[2]] === 2" icone="Icon_notification_mail_3" :cor="estilo.aplicacao.corPrimariaAplicacao"></svg-icone>
        {{ parseDate(row[column.field[1]]) }}
        <span class="hora-enviada">
          {{ parseTime(row[column.field[1]]) }}
        </span>
      </li>
      <li class="notificacao">{{ row[column.field[0]] }}</li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'ColumnInbox',
  props: ['column', 'row', 'frameId'],
  methods: {
    parseDate: function (value) {
      const dataAtual = moment().format('DD/MM/YYYY')
      const formatValue = moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
      if (formatValue === dataAtual) {
        return 'Hoje'
      } else {
        return formatValue
      }
    },
    parseTime: function (value) {
      const timeTz = moment.tz(value, 'America/Sao_Paulo')
      return timeTz.format('HH:mm')
    },
    redirecFuncionalidade (row) {
      let data = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'REDIRECT',
        data: {
          idFuncionalidade: row.id_funcionalidade
        },
        timestamp: Date.now()
      }

      if (row.id_registro && row.id_registro !== '') data.data.idRegistro = row.id_registro
      window.parent.postMessage(data, '*')
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['bundle', 'estilo'])
  }
}

</script>
